import { render, staticRenderFns } from "./NarrowGenreButton.vue?vue&type=template&id=1c625530&scoped=true&lang=pug"
import script from "./NarrowGenreButton.vue?vue&type=script&lang=js"
export * from "./NarrowGenreButton.vue?vue&type=script&lang=js"
import style0 from "./NarrowGenreButton.vue?vue&type=style&index=0&id=1c625530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c625530",
  null
  
)

export default component.exports